import { render, staticRenderFns } from "./UCContractServiceFeesEditor.yaml?vue&type=template&id=5a7c43da&component"
import script from "./UCContractServiceFeesEditor.yaml?vue&type=script&lang=ts&component"
export * from "./UCContractServiceFeesEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports